import { Auditable, FormDataApproval, FormDataSignature, FormEntity, QueryParams, SortParams } from "../..";

export interface FormDataArchiveDetail extends Auditable {
    formDataArchiveId: number;
    data: any;
    signatures: FormDataSignature[];
    approvals: FormDataApproval[];
}

export interface FormDataArchive extends Auditable {
    formDataId: string;
    filePath: string;
    form?: FormEntity;
    details?: FormDataArchiveDetail;
}

export const DefaultFormDataArchiveQueryParams: QueryParams = {
    formDataId: "",
};

export const DefaultFormDataArchiveSortParams: SortParams = {
    orderBy: "createdOn",
    orderDesc: "false",
};
